import { sliders } from "./sliders";

const heroSlider = document.querySelector('.heroSwiper')
const offersSwiper = document.querySelector('.offersSwiper')

sliders(heroSlider,{
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    effect: "fade",
    crossFade: true,
    navigation: {
      nextEl: ".swiper-custom-button-next",
      prevEl: ".swiper-custom-button-prev",
    },
})

sliders(offersSwiper, {
    pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
    },
    effect: "fade",
    crossFade: true,
    navigation: {
        nextEl: ".swiper-custom-button-next",
        prevEl: ".swiper-custom-button-prev",
    },
})

// if heroSlider select .heroNav and if heroSlider has 1 or less slides hide .heroNav
if (heroSlider && heroSlider.querySelectorAll('.swiper-slide').length <= 1) {
  const controlsContainer = heroSlider.querySelector('.heroNav');
  if (controlsContainer) controlsContainer.style.display = 'none';
}
if (offersSwiper && offersSwiper.querySelectorAll('.swiper-slide').length <= 1) {
  const controlsContainer = offersSwiper.querySelector('.controlsContainer');
  if (controlsContainer) controlsContainer.style.display = 'none';
}

